import React from 'react';
import { Modal, Form,Button } from 'antd';

class EmitirModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Emitir Comprobante"}
                visible={this.props.visible}
                okText={"Emitir"}
                cancelText={"Cancelar"}
                destroyOnClose={true}
                onCancel={this.props.onClose}
                onOk={() => {
                    this.props.onEmitir(this.props.form);
                }}
                style={{ top: 30 }}
                width={1200}
                footer={null}
            >
           

                <Form>

                <div className="row">
                        <div className="col-md-8">

                        </div>

                        <div className="col-md-2">
                            <Form.Item>
                                <Button
                                    key="send"
                                    type="danger"
                                    onClick={this.props.onClose}
                                    style={{ width: '100%' }}
                                >
                                    Cancelar
                                </Button>


                            </Form.Item>
                        </div>

                        <div className="col-md-2">
                            <Form.Item>
                                <Button
                                    key="print"
                                    type="primary"
                                    //hidden={true}
                                    onClick={() => {this.props.onEmitir(this.props.form);}}
                                    style={{ width: '100%' }}
                                >
                                    Emitir
                                </Button>
                            </Form.Item>
                        </div>

                    </div>

                     <br/>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>{this.props.item?.serie} {this.props.item?.documento}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.file+ '#view=fitH'}
                                style={{ width: '100%', height: 600 }}
                                type="application/pdf"
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(EmitirModal)